// bao migrate skip 
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoSearchDialog from "./../../factories/bao-search-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import "./../../bindings/bao-number-box";
function ConfigurationItemQualificationViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage, parent);
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.QualificationTabCollection = ko.observableArray([]);
    self.QualificationTabPageIndex = ko.observable(0);
    self.QualificationTabPageIndex.subscribe(function () {
        self.RefreshQualificationGrid();
    });
    self.QualificationTabPageSize = ko.observable(10);
    self.QualificationTabTotalRows = ko.observable(0);
    self.QualificationTabSorting = ko.observableArray();
    self.QualificationTabSorting.subscribe(function () {
        self.RefreshQualificationTabGrid();
    });
    self.SelectedQualificationTabRow = ko.observable({});
    self.SelectedQualificationTabRow.subscribe(function () {
        self.ToggleQualificationTabToolbarButtons();
    });
    self.QualificationTabToolbarButtons = ko.observableArray();
    self.QualificationTabToolbarButtons.subscribe(function () {
        self.ToggleQualificationTabToolbarButtons();
    });
    self.ToggleQualificationTabToolbarButtons = function () {
        ko.utils.arrayForEach(self.QualificationTabToolbarButtons(), function (button: any) {
            if (button.ActionKey() == "ConfigurationItemQualificationTabDelete") {
                button.Enabled(self.SelectedQualificationTabRow() != null);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageQualificationTab = Bao.Session.GetMessage("msgDeleteQualificationTab");
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemQualificationTabNew":
                self.AddQualificationRow();
                break;
            case "ConfigurationItemQualificationTabDelete":
                if (self.SelectedQualificationTabRow() != null) {
                    var selectedData = self.SelectedQualificationTabRow();
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageQualificationTab, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.Delete(selectedData);
                        }
                    });
                }
                break;
        }
    };
    self.Delete = function (selectedData) {
        Bao.post("ConfigurationItemTab/ConfigurationItemQualificationDelete", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: selectedData.ConfigurationItemId,
            qualificationId: selectedData.QualificationId
        }), function (value) {
            parent.TabPage.DirtyFlag(true);
            self.RefreshQualificationTabGrid();
        });
    };
    self.RefreshQualificationTabGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemQualificationCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.QualificationTabPageIndex(),
            pageSize: self.QualificationTabPageSize(),
            sorting: self.QualificationTabSorting()
        }), function (searchResult) {
            self.SelectedQualificationTabRow(null);
            self.QualificationTabTotalRows(0);
            self.QualificationTabCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.QualificationTabCollection(searchResult.Models);
                self.QualificationTabTotalRows(searchResult.TotalRows);
                self.ToggleQualificationTabToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.AddQualificationRow = function () {
        var baoSearchDialog = new BaoSearchDialog();
        var config = {
            MultiSelect: true,
            ObjectId: ko.observable(),
            ObjectValue: "Name",
            SearchType: "Qualification",
            AutoSearch: true,
            CustomFilter: {
                MandatorId: self.ConfigurationItem.ConfigurationItemId()
            },
            ApplyItemCallback: function (searchViewModel) {
                var qualificationIds = [];
                ko.utils.arrayForEach(searchViewModel.Selection(), function (item: any) {
                    qualificationIds.push(item.QualificationId);
                });
                Bao.post("ConfigurationItemTab/AddQualification", JSON.stringify({
                    sessionTabId: self.ConfigurationItem.SessionTabId(),
                    configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
                    qualificationIds: qualificationIds
                }), function () {
                    parent.TabPage.DirtyFlag(true);
                    self.RefreshQualificationTabGrid();
                });
            }
        };
        baoSearchDialog.InitSearcher(config);
    };
    self.Save = function (model) {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItem100QualificationTab/SaveConfigurationItemQualification", JSON.stringify({
            sessionTabId: self.ConfigurationItem.SessionTabId(),
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            saveTime: parent.SaveTime()
        }));
    };
    self.Refresh = function () {
        return self.RefreshQualificationTabGrid();
    };
    self.loaded = function () {
        return self.Refresh();
    };
}
;
Bao.inherit(ConfigurationItemQualificationViewModel, ChildTabViewModel);
export default ConfigurationItemQualificationViewModel;